import { Button, Group, HoverCard, Image, Text } from '@mantine/core';
import { IconDownload, IconInfoCircle } from '@tabler/icons-react';
import dayjs from 'dayjs';
import * as React from 'react';

import { useAuth } from '../../../contexts/AuthProvider';
import { useI18n } from '../../../contexts/I18nProvider';
import { HISTOPAIE_HOST } from '../../../variables/GlobalVariables';

type Props = {
  userId: string;
};

export default function HistoPaieConnector({ userId }: Props) {
  const { user } = useAuth();
  const { t } = useI18n();

  function onConnectClick() {
    window.open(
      `${HISTOPAIE_HOST}/register?origin=hifivework&empId=${userId}`,
      '_blank'
    );
  }

  function goToHistoPaieLoginPage() {
    window.open(HISTOPAIE_HOST, '_blank');
  }

  function onDownloadCertificateClick() {
    window.open(
      `https://certificates.infocert.org/ouvrir_certificat.php?id_elmt=3613&fichier=CERTIF_203483-1_EXASECURITY_EXASAFE+%283%29.pdf&HR=09:21:04${dayjs()
        .utc()
        .format('HH:MM:SS')}`,
      '_blank'
    );
  }

  if (user.id !== userId) return null;

  return (
    <>
      <HoverCard width={280} shadow="md">
        <HoverCard.Target>
          <IconInfoCircle />
        </HoverCard.Target>
        <HoverCard.Dropdown>
          <Group>
            <Text>{t('histopaie.safeTitle')}</Text>
            <Text c="dimmed" size="xs">
              {t('histopaie.safeDesc1')}
            </Text>
            <Image
              radius="md"
              h={50}
              w="auto"
              fit="contain"
              src="/images/certif/afnor.png"
            />
            <Button
              size="xs"
              variant="transparent"
              onClick={onDownloadCertificateClick}
            >
              <IconDownload />
              {t('histopaie.downloadCertificate')}
            </Button>
          </Group>
        </HoverCard.Dropdown>
      </HoverCard>
      {user.histoPaie ? (
        <Button size="xs" onClick={goToHistoPaieLoginPage}>
          {t('histopaie.showPayslips')}
        </Button>
      ) : (
        <Button size="xs" onClick={onConnectClick}>
          {t('histopaie.createAccount')}
        </Button>
      )}
    </>
  );
}
